import {
    useCalendly,
    usePhonePattern,
    useUnmuteVideo
} from "marketingWebsite/sales/index.js"

// Aggregate and calls functions that are unique only for sales page

useCalendly()
usePhonePattern()
useUnmuteVideo()
